import React from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { AppBar, Toolbar, Typography, Button, Grid, Card, CardContent, Container, Step, BottomNavigation, BottomNavigationAction, Paper } from '@mui/material'; // Import Paper, BottomNavigation, BottomNavigationAction
import HomeIcon from '@mui/icons-material/Home'; // Example icons
import SearchIcon from '@mui/icons-material/Search';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import GroupIcon from '@mui/icons-material/Group';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import { AuthProvider, useAuth } from './auth/AuthContext.js';
import ProtectedRoute from './auth/ProtectedRoute.js';
import Header from './Header.jsx';

// import
import INDEX from './screens/YouKnowLanding.jsx'
import ELOGIN from './screens/EmailLogin.jsx'
import NEWBOLO from './screens/NewBolo.jsx'
import NEWPROP from './screens/NewProperty.jsx'
import STEP1 from './screens/AdminPanel.jsx'
import ADMINBETA from './screens/AdminPanelBeta.jsx'
import STEP2 from './screens/NewGroup.jsx'
import ACTIVITIES from './screens/PublicActivities.jsx'
import PROFILE from './screens/Profile.jsx'
import PROFILES from './screens/PublicProfiles.jsx'
// import GOFORIT from './screens/Goforit'
import GROUPS from './screens/PublicGroups.jsx'
import GROUPSINMAP from './screens/PublicGroupsInMap.jsx'
import InitialView from './screens/MainView.jsx'
import { NotificationProvider } from './notification/NotificationProvider.js';
import { SpeakerOutlined } from '@mui/icons-material';
import SVGComponent from './screens/svgviewer-react-output-remaster.js';
import SVGComponentFooterEvents from './screens/svgviewer-react-output-events.js'
import SVGComponentFooterRockHand from './screens/svgviewer-react-output-events-stream.js';
import SVGComponentFooterChats from './screens/svgviewer-react-output-headphones.js';
import PublicPropertyView from './screens/PublicPropertyView.jsx';
import GroupPublicPage from './screens/PublicGroupLandingPage.jsx';
// Create the theme with black and white colors
const theme = createTheme({
  palette: {
    primary: {
      main: '#000000',
    },
    secondary: {
      main: '#FFFFFF',
    },
    background: {
      default: '#FFFFFF',
      paper: '#FFFFFF'
    },
    text: {
      primary: '#000000',
      secondary: '#555555'
    }
  },
});

function Miniroutes() {
  const location = useLocation();
  const navigate = useNavigate();
  const [value, setValue] = React.useState(0);

  // Define which routes should NOT render the header/footer
  const isFullScreenRoute = location.pathname.startsWith('/misbolos/weare/');
  console.log('Current route:', location.pathname, 'Is full screen route:', isFullScreenRoute);
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <NotificationProvider>
          {/* Only show header/footer if not a full screen route */}
          {!isFullScreenRoute && <Header />}

          <div style={{ flexGrow: 1, paddingBottom: isFullScreenRoute ? 0 : '56px' }}>
            <Routes>
              <Route path="/" element={<InitialView />} />
              <Route path="/profile" element={<PROFILE />} />
              <Route path="/login" element={<INDEX />} />
              <Route path="/elogin" element={<ELOGIN />} />
              <Route path="/admin" element={<ADMINBETA />} />
              <Route path="/admin-old" element={<STEP1 />} />
              <Route path="/newGroup" element={<STEP2 />} />
              <Route path="/activities/:activityTitle?" element={<ACTIVITIES />} />
              <Route path="/groups/:groupName?" element={<GROUPS />} />
              <Route path="/groupsinmap/:groupName?" element={<GROUPSINMAP />} />
              <Route path="/users/:email?" element={<PROFILES />} />
              <Route path="/newbolo" element={<NEWBOLO />} />
              <Route path="/newproperty" element={<NEWPROP />} />
              <Route path="/property/:name" element={<PublicPropertyView />} />
              <Route path="/weare/:groupName" element={<GroupPublicPage />} />
            </Routes>
          </div>

          {/* Only show footer if not a full screen route */}
          {!isFullScreenRoute && (
            <Paper
              sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                width: '100vw',
                zIndex: 1000,
              }}
              elevation={3}
            >
              <BottomNavigation
                showLabels
                value={value}
                onChange={(event, newValue) => {
                  setValue(newValue);
                  switch (newValue) {
                    case 0:
                      navigate('/misbolos/users');
                      break;
                    case 1:
                      navigate('/misbolos/groups');
                      break;
                    case 2:
                      navigate('/misbolos/activities');
                      break;
                    case 3:
                      navigate('/misbolos/admin');
                      break;
                    case 4:
                      navigate('/misbolos/profile');
                      break;
                  }
                }}
              >
                <BottomNavigationAction label="Músicos" icon={<SVGComponentFooterChats />} />
                <BottomNavigationAction label="Grupos" icon={<SVGComponentFooterEvents />} />
                <BottomNavigationAction label="Eventos" icon={<SVGComponentFooterRockHand />} />
                <BottomNavigationAction label="MisBandas" icon={<SVGComponent />} />
              </BottomNavigation>
            </Paper>
          )}
        </NotificationProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}


export default Miniroutes;
{/* <BottomNavigationAction label="Perfil" icon={<AccountCircleIcon />} /> */ }